import { IChatMessagesOut, ShowTypingState } from '@enuan/chat__utils';
import { createContext } from 'react';

export type ISubmitContextState = {
	message?: IChatMessagesOut;
	action?: 'texting' | 'recording' | 'attaching';
	error?: string;
	composingState: ShowTypingState | undefined;
};

export type ISubmitContextCallback = {
	setMessage: (message: ISubmitContextState['message']) => void;
	setAction: (state: ISubmitContextState['action']) => void;
	setError: (error: ISubmitContextState['error']) => void;
	setComposingState: React.Dispatch<
		React.SetStateAction<ISubmitContextState['composingState']>
	>;

	submitForm: (message?: ISubmitContextState['message']) => Promise<string>;
};
type ISubmitContext = ISubmitContextState & ISubmitContextCallback;

export const submitContext = createContext({} as ISubmitContext);
